<div class="recursos-page">
  <header class="recursos-page__cabecalho">
    <div>
      <h1><i class="fas fa-compass" aria-hidden="true"></i> Módulos e recursos</h1>
      <p>Encontre os módulos e os recursos que ajudam na operação da sua loja.</p>
    </div>
  </header>

  <section class="recursos-intro">
    <span class="recursos-intro__icone"><i class="fas fa-store" aria-hidden="true"></i></span>
    <div>
      <h2>Descubra novas possibilidades para sua loja</h2>
      <p>Veja como novas funcionalidades podem ajudar no atendimento, nas vendas e na gestão. Explore as demonstrações e conte para nossa equipe o que despertou seu interesse.</p>
    </div>
  </section>

  <nav class="recursos-abas" aria-label="Situação dos módulos e recursos">
    <button type="button" [class.ativa]="aba === 'CONHECER'" [attr.aria-pressed]="aba === 'CONHECER'" (click)="selecioneAba('CONHECER')">
      Para conhecer <span>{{recursosParaConhecer.length}}</span>
    </button>
    <button type="button" [class.ativa]="aba === 'ATIVOS'" [attr.aria-pressed]="aba === 'ATIVOS'" (click)="selecioneAba('ATIVOS')">
      Você já possui <span>{{recursosAtivos.length}}</span>
    </button>
    <button type="button" [class.ativa]="aba === 'INTERESSES'" [attr.aria-pressed]="aba === 'INTERESSES'" (click)="selecioneAba('INTERESSES')">
      Meus interesses <span>{{interesses.length}}</span>
    </button>
  </nav>

  <div class="recursos-estado" *ngIf="carregando" role="status">
    <i class="fa fa-spin fa-spinner" aria-hidden="true"></i>
    <span>Carregando recursos...</span>
  </div>

  <div class="alert alert-danger recursos-alerta" *ngIf="erroCarregamento" role="alert">
    <i class="fas fa-exclamation-circle mr-1" aria-hidden="true"></i>
    {{erroCarregamento}}
    <button type="button" class="btn btn-outline-danger btn-sm ml-2" (click)="recarregue()">Tentar novamente</button>
  </div>

  <ng-container *ngIf="!carregando && !erroCarregamento">
    <ng-container *ngIf="aba !== 'INTERESSES'">
      <div class="recursos-filtros">
        <div class="recursos-filtros__busca">
          <label for="busca-recursos">Buscar funcionalidade</label>
          <input id="busca-recursos" class="form-control" type="search" [(ngModel)]="busca" placeholder="Nome, módulo ou o que você deseja fazer">
        </div>
        <div class="recursos-filtros__modulo">
          <label for="filtro-modulo">Módulo ou área</label>
          <select id="filtro-modulo" class="form-control" [(ngModel)]="moduloFiltro">
            <option value="">Todos os módulos e áreas</option>
            <option *ngFor="let grupo of modulosDaAba; trackBy: identifiqueModulo" [value]="grupo.modulo?.slug || 'outros-recursos'">{{tituloRecurso(grupo.modulo)}}</option>
          </select>
        </div>
        <button type="button" class="btn btn-link" (click)="limpeFiltros()" *ngIf="busca || moduloFiltro">Limpar filtros</button>
      </div>
      <p class="recursos-resultados" role="status">{{quantidadeVisivel}} {{quantidadeVisivel === 1 ? 'funcionalidade' : 'funcionalidades'}} em {{modulosVisiveis.length}} {{modulosVisiveis.length === 1 ? 'módulo ou área' : 'módulos e áreas'}}</p>
      <div class="recursos-vazio" *ngIf="modulosDaAba.length && !modulosVisiveis.length">
        <i class="fas fa-search" aria-hidden="true"></i>
        <h2>Nenhuma funcionalidade encontrada</h2>
        <p>Experimente outro termo ou veja todos os módulos desta aba.</p>
        <button type="button" class="btn btn-primary" (click)="limpeFiltros()">Limpar filtros</button>
      </div>
    </ng-container>

    <section class="modulo-secao" *ngFor="let grupo of modulosVisiveis; trackBy: identifiqueModulo"
             [attr.aria-labelledby]="'modulo-' + (grupo.modulo?.slug || 'outros')">
      <header class="modulo-secao__cabecalho">
        <span class="modulo-secao__icone"><i class="fas" [ngClass]="grupo.modulo ? iconeRecurso(grupo.modulo) : 'fa-puzzle-piece'" aria-hidden="true"></i></span>
        <div class="modulo-secao__identidade">
          <span class="modulo-secao__categoria">{{grupo.modulo?.categoria || 'Outras possibilidades'}}</span>
          <h2 [id]="'modulo-' + (grupo.modulo?.slug || 'outros')">{{tituloRecurso(grupo.modulo)}}</h2>
          <p>{{grupo.modulo?.descricaoCurta || 'Conheça os recursos disponíveis para complementar sua operação.'}}</p>
          <span class="modulo-secao__nota" *ngIf="grupo.modulo?.agrupador">Contratação por recurso</span>
        </div>
        <div class="modulo-secao__acao" *ngIf="grupo.principal as principal">
          <span class="modulo-secao__status modulo-secao__status--ativo" *ngIf="principal.status === 'ATIVO'">
            <i class="fas fa-check-circle" aria-hidden="true"></i> Você já possui o módulo
          </span>
          <span class="modulo-secao__status modulo-secao__status--pendente" *ngIf="principal.status === 'PENDENTE'">
            <i class="fas fa-clock" aria-hidden="true"></i> Contratação em andamento
          </span>
          <span class="modulo-secao__status modulo-secao__status--ativo" *ngIf="principal.status === 'INCLUIDO'">
            <i class="fas fa-check-circle" aria-hidden="true"></i> Incluído no seu plano · aguardando liberação
          </span>
          <ng-container *ngIf="principal.status === 'DISPONIVEL'">
            <span class="modulo-secao__preco">{{rotuloContratacao(principal)}}</span>
          </ng-container>
          <button type="button" class="btn btn-outline-primary" (click)="abraDetalhes(principal)">
            {{principal.status === 'DISPONIVEL' ? 'Conhecer módulo' : 'Ver como funciona'}}
            <i class="fas fa-arrow-right ml-1" aria-hidden="true"></i>
          </button>
        </div>
      </header>

      <ng-container *ngIf="aba === 'CONHECER'; else recursosAtivosDoModulo">
        <ng-container *ngTemplateOutlet="listaRecursos; context: {$implicit: filtrePorContratacao(grupo.recursos, 'PAGO'), contratacao: 'PAGO'}"></ng-container>
        <ng-container *ngTemplateOutlet="listaRecursos; context: {$implicit: filtrePorContratacao(grupo.recursos, 'CONSULTAR'), contratacao: 'CONSULTAR'}"></ng-container>
        <ng-container *ngTemplateOutlet="listaRecursos; context: {$implicit: filtrePorContratacao(grupo.recursos, 'GRATUITO'), contratacao: 'GRATUITO'}"></ng-container>
      </ng-container>
      <ng-template #recursosAtivosDoModulo>
        <ng-container *ngTemplateOutlet="listaRecursos; context: {$implicit: grupo.recursos}"></ng-container>
      </ng-template>

      <ng-template #listaRecursos let-recursos let-contratacao="contratacao">
        <div class="modulo-secao__recursos" *ngIf="recursos.length">
          <div class="modulo-secao__subtitulo">
            <h3>{{aba === 'ATIVOS' ? 'Recursos da sua loja' : contratacao === 'GRATUITO' ? 'Recursos gratuitos' : contratacao === 'CONSULTAR' ? 'Mais funcionalidades para conhecer' : 'Adicionais pagos'}}</h3>
            <span>{{recursos.length}} {{recursos.length === 1 ? 'recurso' : 'recursos'}} {{aba === 'ATIVOS' ? 'na sua loja' : 'para conhecer'}}</span>
          </div>
          <p class="modulo-secao__ajuda" *ngIf="aba === 'CONHECER' && contratacao === 'PAGO'">
            Conheça os benefícios. Nossa equipe apresenta os valores para sua loja.
          </p>
          <p class="modulo-secao__ajuda" *ngIf="aba === 'CONHECER' && contratacao === 'CONSULTAR'">
            Nossa equipe confirma se o recurso já faz parte do seu plano e como disponibilizá-lo na sua loja.
          </p>
          <div class="recursos-grade" [class.recursos-grade--unica]="recursos.length === 1" [class.recursos-grade--dupla]="recursos.length === 2">
            <article class="recurso-card" *ngFor="let recurso of recursos; trackBy: identifiqueRecurso">
              <button type="button" class="recurso-card__previa" *ngIf="apresentacoes[recurso.slug]?.previa as previa"
                      (click)="abraDetalhes(recurso)" [attr.aria-label]="'Ver demonstração de ' + tituloRecurso(recurso)">
                <span class="recurso-card__imagem" aria-hidden="true"><app-previa-recurso [previa]="previa" [miniatura]="true"></app-previa-recurso></span>
                <span class="recurso-card__ampliar" aria-hidden="true"><i class="fas fa-expand-alt"></i> Ver demonstração</span>
              </button>
              <div class="recurso-card__conteudo">
                <div class="recurso-card__topo">
                  <span class="recurso-card__icone"><i class="fas" [ngClass]="iconeRecurso(recurso)" aria-hidden="true"></i></span>
                  <span class="recurso-card__categoria">{{recurso.categoria}}</span>
                </div>
                <span class="recurso-card__contratacao" [class.recurso-card__contratacao--gratuito]="recurso.gratuito" [class.recurso-card__contratacao--consulta]="recurso.contratacao === 'CONSULTAR'" *ngIf="aba === 'CONHECER'">{{rotuloContratacao(recurso)}}</span>
                <h4>{{tituloRecurso(recurso)}}</h4>
                <p>{{recurso.descricaoCurta}}</p>
                <div class="recurso-card__status recurso-card__acao--pendente" *ngIf="recurso.status === 'PENDENTE'">
                  <i class="fas fa-clock" aria-hidden="true"></i> Contratação em andamento
                </div>
                <div class="recurso-card__status recurso-card__acao--incluido" *ngIf="recurso.status === 'INCLUIDO'">
                  <i class="fas fa-clock" aria-hidden="true"></i> Incluído no seu plano · aguardando liberação
                </div>
                <div class="recurso-card__status recurso-card__acao--ativo" *ngIf="recurso.status === 'ATIVO'">
                  <i class="fas fa-check-circle" aria-hidden="true"></i> Disponível na sua loja
                </div>
                <div class="recurso-card__status recurso-card__acao--ativo" *ngIf="recurso.status === 'DISPONIVEL' && obtenhaInteresseAberto(recurso.slug)">
                  <i class="fas fa-check-circle" aria-hidden="true"></i> Interesse registrado
                </div>
                <button type="button" class="recurso-card__acao" (click)="abraDetalhes(recurso)">
                  Ver como funciona <i class="fas fa-arrow-right" aria-hidden="true"></i>
                </button>
              </div>
            </article>
          </div>
        </div>
      </ng-template>
    </section>

    <section *ngIf="aba === 'INTERESSES' && interesses.length" aria-label="Interesses registrados">
      <article class="interesse-card" *ngFor="let interesse of interesses">
        <span class="recurso-card__icone">
          <i class="fas" [ngClass]="iconeRecurso(obtenhaRecursoDoInteresse(interesse) || {slug: interesse.recurso.slug})" aria-hidden="true"></i>
        </span>
        <div class="interesse-card__conteudo">
          <h2>{{tituloRecurso(interesse.recurso)}}</h2>
          <p>Solicitado em {{interesse.criadoEm | date:'dd/MM/yyyy'}} · {{rotuloStatusInteresse(interesse.status)}}</p>
        </div>
        <button type="button" class="btn btn-link" *ngIf="obtenhaRecursoDoInteresse(interesse) as recurso" (click)="abraDetalhes(recurso)">Ver como funciona</button>
        <span class="interesse-card__status" [class.interesse-card__status--concluido]="interesse.status === 'CONCLUIDO'">
          <i class="fas fa-check" aria-hidden="true"></i> {{rotuloStatusInteresse(interesse.status)}}
        </span>
      </article>
      <p class="recursos-ajuda">Sua solicitação não altera a assinatura da loja.</p>
    </section>

    <div class="recursos-vazio" *ngIf="aba === 'CONHECER' && !recursosParaConhecer.length">
      <i class="fas fa-check-circle" aria-hidden="true"></i>
      <h2>Nenhum módulo ou recurso disponível para conhecer</h2>
      <p>Os novos recursos compatíveis com sua loja aparecerão aqui.</p>
    </div>
    <div class="recursos-vazio" *ngIf="aba === 'ATIVOS' && !recursosAtivos.length">
      <i class="fas fa-puzzle-piece" aria-hidden="true"></i>
      <h2>Nenhum módulo ou recurso ativo encontrado</h2>
      <p>Quando um recurso estiver disponível na loja, ele aparecerá nesta aba.</p>
    </div>
    <div class="recursos-vazio" *ngIf="aba === 'INTERESSES' && !interesses.length">
      <i class="far fa-comment-dots" aria-hidden="true"></i>
      <h2>Seus interesses aparecem aqui</h2>
      <p>Conheça um recurso e use “Tenho interesse” para conversar com nossa equipe.</p>
      <button type="button" class="btn btn-primary" (click)="selecioneAba('CONHECER')">Explorar recursos</button>
    </div>
  </ng-container>

  <p class="recursos-rodape"><i class="fas fa-info-circle" aria-hidden="true"></i> A contratação é feita com a nossa equipe.</p>
</div>

<div class="recurso-modal-fundo" *ngIf="recursoSelecionado" (click)="fecheDetalhes()">
  <section class="recurso-modal" role="dialog" aria-modal="true" aria-labelledby="recurso-modal-titulo"
           cdkTrapFocus [cdkTrapFocusAutoCapture]="true" tabindex="-1"
           (keydown.escape)="fecheDetalhes()" (click)="$event.stopPropagation()">
    <header>
      <div class="recurso-modal__titulo">
        <span class="recurso-card__icone"><i class="fas" [ngClass]="iconeRecurso(recursoSelecionado)" aria-hidden="true"></i></span>
        <div>
          <span>{{recursoSelecionado.categoria}}</span>
          <h2 id="recurso-modal-titulo">{{tituloRecurso(recursoSelecionado)}}</h2>
        </div>
      </div>
      <button type="button" class="recurso-modal__fechar" aria-label="Fechar detalhes" (click)="fecheDetalhes()">&times;</button>
    </header>

    <div class="recurso-modal__corpo" tabindex="0" role="region" aria-label="Apresentação do recurso">
      <div class="recurso-modal__contratacao" [class.recurso-modal__contratacao--gratuito]="recursoSelecionado.gratuito || recursoSelecionado.status === 'INCLUIDO'" [class.recurso-modal__contratacao--consulta]="recursoSelecionado.contratacao === 'CONSULTAR' && recursoSelecionado.status !== 'INCLUIDO'" *ngIf="recursoSelecionado.status !== 'ATIVO'">
        <strong>{{rotuloContratacao(recursoSelecionado)}}</strong>
        <p *ngIf="recursoSelecionado.status === 'INCLUIDO'; else condicoesRecurso">A contratação já inclui este recurso. A liberação na loja ainda não foi concluída.</p>
        <ng-template #condicoesRecurso>
          <p *ngIf="recursoSelecionado.contratacao === 'CONSULTAR'">Nossa equipe verifica se este recurso já está incluído no seu plano e orienta como disponibilizá-lo. Você pode demonstrar interesse sem assumir uma contratação.</p>
          <p *ngIf="recursoSelecionado.contratacao === 'PAGO'">Contratação à parte. Nossa equipe apresenta os valores e as condições para a sua loja.</p>
        </ng-template>
      </div>
      <p class="recurso-modal__vinculo" *ngIf="recursoSelecionado.recursoPai">Recurso relacionado ao módulo <strong>{{tituloRecurso(recursoSelecionado.recursoPai)}}</strong></p>
      <p class="recurso-modal__descricao">{{recursoSelecionado.descricaoCurta}}</p>

      <div class="recurso-apresentacao" *ngIf="apresentacaoSelecionada as apresentacao" [class.recurso-apresentacao--sem-previa]="!apresentacao.previa">
        <div class="recurso-apresentacao__previa" *ngIf="apresentacao.previa">
          <div class="recurso-apresentacao__cabecalho">
            <h3>Veja na prática</h3>
            <span>Captura da interface real</span>
          </div>
          <app-previa-recurso [previa]="apresentacao.previa"></app-previa-recurso>
        </div>
        <aside class="recurso-apresentacao__beneficios">
          <h3>O que você pode fazer</h3>
          <ul>
            <li *ngFor="let beneficio of apresentacao.beneficios"><i class="fas fa-check-circle" aria-hidden="true"></i><span>{{beneficio}}</span></li>
          </ul>
          <div class="recurso-apresentacao__requisito" *ngIf="apresentacao.requisito">
            <h4><i class="fas fa-info-circle" aria-hidden="true"></i> Para usar na sua loja</h4>
            <p>{{apresentacao.requisito}}</p>
          </div>
        </aside>
      </div>

      <div class="recurso-modal__nota" *ngIf="recursoSelecionado.status === 'PENDENTE'">
        <i class="fas fa-clock" aria-hidden="true"></i>
        A contratação deste recurso já está em andamento.
      </div>
      <div class="recurso-modal__nota recurso-modal__nota--ativo" *ngIf="recursoSelecionado.status === 'ATIVO'">
        <i class="fas fa-check-circle" aria-hidden="true"></i>
        Este recurso já está disponível na sua loja.
      </div>
      <div class="recurso-modal__nota recurso-modal__nota--sucesso" *ngIf="interesseConfirmadoSlug === recursoSelecionado.slug" role="status">
        <i class="fas fa-check-circle" aria-hidden="true"></i>
        Interesse recebido. Nossa equipe entrará em contato.
      </div>
      <div class="alert alert-danger mb-0" *ngIf="erroSolicitacao" role="alert">{{erroSolicitacao}}</div>
    </div>

    <footer>
      <p *ngIf="recursoSelecionado.status === 'DISPONIVEL'">Demonstrar interesse não gera cobrança<br>nem ativa o recurso automaticamente.</p>
      <p *ngIf="recursoSelecionado.status === 'ATIVO'">Este recurso já está disponível na sua loja.</p>
      <p *ngIf="recursoSelecionado.status === 'INCLUIDO'">Recurso incluído no plano, aguardando liberação.</p>
      <p *ngIf="recursoSelecionado.status === 'PENDENTE'">A contratação deste recurso já está em andamento.</p>
      <a class="btn recurso-modal__acao" *ngIf="rotaDoRecurso(recursoSelecionado) as rota" [routerLink]="rota">Acessar recurso <i class="fas fa-arrow-right ml-1" aria-hidden="true"></i></a>
      <button type="button" class="btn recurso-modal__acao" [disabled]="salvandoInteresse"
              *ngIf="podeSolicitar(recursoSelecionado)" (click)="soliciteInteresse()">
        <i [class]="salvandoInteresse ? 'fa fa-spin fa-spinner' : 'far fa-comment-dots'" aria-hidden="true"></i>
        {{salvandoInteresse ? 'Registrando...' : 'Tenho interesse'}}
      </button>
      <button type="button" class="btn recurso-modal__acao recurso-modal__acao--confirmado"
              *ngIf="obtenhaInteresseAberto(recursoSelecionado.slug)" (click)="selecioneAba('INTERESSES'); fecheDetalhes()">
        <i class="fas fa-check-circle" aria-hidden="true"></i> Ver meu interesse
      </button>
    </footer>
  </section>
</div>
